var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.97546 2.1355L27.2248 13.2559C27.4595 13.3682 27.6576 13.5446 27.7963 13.7648C27.935 13.9849 28.0086 14.2398 28.0086 14.5C28.0086 14.7602 27.935 15.0151 27.7963 15.2352C27.6576 15.4554 27.4595 15.6318 27.2248 15.7441L3.97546 26.8645C3.73703 26.9788 3.47076 27.0221 3.20839 26.9894C2.94602 26.9566 2.69859 26.8491 2.49557 26.6797C2.29256 26.5103 2.14252 26.2861 2.06332 26.0338C1.98413 25.7816 1.97911 25.5118 2.04887 25.2568L4.37491 16.7295C4.40338 16.625 4.46198 16.5312 4.54342 16.4597C4.62485 16.3883 4.7255 16.3424 4.83283 16.3278L16.0989 14.7974C16.1458 14.7908 16.1903 14.7722 16.228 14.7434C16.2657 14.7146 16.2953 14.6766 16.314 14.633L16.3339 14.5634C16.3426 14.5018 16.3302 14.4391 16.2988 14.3854C16.2673 14.3317 16.2187 14.2903 16.1607 14.2677L16.1 14.2512L4.84497 12.7218C4.73784 12.707 4.63742 12.661 4.5562 12.5896C4.47499 12.5182 4.41654 12.4245 4.38815 12.3202L2.04887 3.7432C1.97911 3.48816 1.98413 3.21844 2.06332 2.96616C2.14252 2.71389 2.29256 2.4897 2.49557 2.32029C2.69859 2.15088 2.94602 2.04339 3.20839 2.01063C3.47076 1.97787 3.73703 2.02121 3.97546 2.1355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.dbc9dd11ef88c3053fe16b3c9493fe58.svg";
export { ForwardRef as ReactComponent };